/**
 * Cross-client identity super properties (see PostHog cross-platform taxonomy).
 *
 * `client` distinguishes this web editor from other clients that share the same
 * `$lib` (posthog-js), notably the webxr viewer. It must ride every event,
 * including the auto-captured $pageview, so it is registered as a PostHog super
 * property rather than passed per-capture.
 */

import { runtimeEnv } from '@/lib/runtimeEnv';

export const LUREO_CLIENT = 'web' as const;

/** Which environment this build is: the same value New Relic's events carry (VITE_NR_BROWSER_ENV), production unless set. */
export const LUREO_ENVIRONMENT: string = runtimeEnv.VITE_NR_BROWSER_ENV ?? 'production';

interface RegisterablePostHog {
  register?(properties: Record<string, unknown>): void;
}

/**
 * Register the cross-client identity super properties. Safe to call repeatedly:
 * posthog.reset() clears super properties, so this is re-invoked after every reset
 * (logout, consent downgrade) as well as once at load.
 */
export function registerLureoSuperProps(posthog: RegisterablePostHog | null | undefined): void {
  posthog?.register?.({
    client: LUREO_CLIENT,
    app_version: __APP_VERSION__,
    environment: LUREO_ENVIRONMENT,
  });
}
